import { Color } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  column: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  label: {
    fontSize: 8,
    color: Color.Grey700,
    textTransform: 'uppercase',
  },
  heading: {
    fontSize: 14,
    color: Color.Black,
    textTransform: 'uppercase',
  },
})
